export default function ForumIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M7 9.49995H13M7 6.49995H13M5.31106 14.876L2.23261 17.4638C2.12328 17.5557 1.98999 17.6145 1.8484 17.6332C1.70681 17.652 1.56281 17.6299 1.43334 17.5696C1.30387 17.5093 1.19431 17.4133 1.11755 17.2928C1.04078 17.1724 1 17.0325 1 16.8897V2C1 1.80109 1.07902 1.61032 1.21967 1.46967C1.36032 1.32902 1.55109 1.25 1.75 1.25H18.25C18.4489 1.25 18.6397 1.32902 18.7803 1.46967C18.921 1.61032 19 1.80109 19 2V14C19 14.1989 18.921 14.3897 18.7803 14.5303C18.6397 14.671 18.4489 14.75 18.25 14.75H5.65665L5.31106 14.876Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
